import { Deserializable } from "../deserializable";

export class UserFiaPinDocument implements Deserializable {

    public incomeTaxReferenceNumber: string;
    public caseNumber: number;
    public requestRefNumber: string;
    public status: number;
    public pin: string;
    public pinIssueDate: Date;
    public pinExpiryDate: Date;
    public fileClassification: string;

    deserialize(input: any): this {
        Object.assign(this, input);
        return this;
    }
}
